import { AxiosRequestConfig } from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import { GetSubscriptionSetData } from "../../../../Api/ServiceDatas";
import { useApi } from "../../../../hooks/useApi";
import { authType } from "../../../../pages/Login";
import LineBtn from "../../../Button/LineBtn";
import Blank from "../../../DefaultStyles/Blank";
import Flex from "../../../DefaultStyles/Flex";
import LineBox from "../../../DefaultStyles/LineBox";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import AlertModal from "../../../Modal/AlertModal";
import VerticalTable from "../../../Table/VerticalTable";
import SecretModeSetModal from "./SecretModeSetModal/SecretModeSetModal";
import RecruitmentSetModal from "./RecruitmentSetModal/RecruitmentSetModal";
import EndDateSetModal from "./EndDateSetModal/EndDateSetModal";
import { GetSubscriptionSetData_V3 } from "../../../../ApiTS/ServiceDatasTS_V3";
import {
  getString3ByKey,
  getSubsNameBySubsId3,
} from "../../../../AdminApi/3.0_utils";

interface SSecretTime {
  isSecret?: string;
}

interface SPartyDateContainer {
  hasExitDate: boolean;
}

interface PartyDetailDefaultInfoProps {
  data?: {
    partyid?: string;
    servsubsid?: number;
    owner?: string;
    ownerName?: string;
    ownerNickname?: string;
    startdate?: string;
    enddate?: string;
    isSecret?: string;
    maxmemb?: boolean;
    members?: boolean;
    exitdate?: string;
    state?: number;
    parentPid?: number;
    parentServsubsid?: number;
    childPid?: number;
    childServsubsid?: number;
    invitememb?: number;
  };
  status?: number;
  fetchData: (params: AxiosRequestConfig) => Promise<void>;
}

export default function PartyDetailDefaultInfo({
  data,
  status,
  fetchData,
}: PartyDetailDefaultInfoProps) {
  const auth = useRecoilValue(authType);

  const navigate = useNavigate();

  const [secretSetModal, setSecretSetModal] = useState(false);
  const [secretOffAlertModal, setSecretOffAlertModal] = useState(false);
  const [secretModeOffBtnClick, setSecretModeOffBtnClick] = useState(false);
  const [recruitmentSetModal, setRecruitmentSetModal] = useState(false);
  const [endDateSetModal, setEndDateSetModal] = useState(false);

  const isInfinity = data?.enddate === "9999-12-31";

  const { response } = useApi({
    method: "post",
    url: secretModeOffBtnClick ? `party/${data?.partyid}/secret` : undefined,
    data: {
      date: `${dayjs()?.format("YYYY-MM-DD HH:mm:ss")}`,
    },
  });

  useEffect(() => {
    console.log(response, "2222");

    if (response?.status === 200) {
      setSecretOffAlertModal(false);

      fetchData({
        method: "get",
        url: `party/${data?.partyid}`,
      });

      toast.success("시크릿 모드가 해제되었습니다.", {});
    }
  }, [response]);

  const defaultInfoHeader = [
    "Subscription",
    "파티장 ID",
    "파티 기간",
    "모집 인원",
    "시크릿 모드",
    data?.parentPid ? "이전 파티" : null,
    data?.childPid ? "연장 파티" : null,
  ];

  const defaultInfoBody = [
    [
      `${data?.servsubsid}_${getString3ByKey(
        GetSubscriptionSetData_V3(data?.servsubsid ?? 0)?.SUBS_NM ?? 0,
      )}`,
    ],
    [
      `${data?.owner}_${data?.ownerName}_${data?.ownerNickname}`,
      <ArrowBtn
        className="material-icons-outlined"
        onClick={() => navigate(`/users/info/${data?.owner}`)}
      >
        chevron_right
      </ArrowBtn>,
    ],
    [
      <PartyDateContainer hasExitDate={data?.exitdate !== "" ? true : false}>
        <Date>{data?.startdate}~</Date>

        {isInfinity ? (
          data?.state === 1 ? (
            ""
          ) : (
            <Date>
              {dayjs(data?.exitdate !== "" ? data?.exitdate : data?.enddate)
                ?.add(-1, "day")
                ?.format("YYYY-MM-DD")}
            </Date>
          )
        ) : (
          <Flex>
            <>
              {data?.exitdate !== "" && (
                <ExitDate>
                  {dayjs(data?.enddate).add(-1, "day")?.format("YYYY-MM-DD")}
                </ExitDate>
              )}
            </>
            <Date>
              {dayjs(data?.exitdate !== "" ? data?.exitdate : data?.enddate)
                ?.add(-1, "day")
                ?.format("YYYY-MM-DD")}
            </Date>
          </Flex>
        )}
      </PartyDateContainer>,
      <>
        <LineBtn
          btnText="설정"
          btnColor="white"
          disabled={!auth?.partyInfo}
          btnClickEvent={() => {
            return setEndDateSetModal(true);
          }}
          style={{ marginLeft: "auto" }}
        />
      </>,
    ],
    [
      // <Flex>
      <>
        <span>{data?.members}/</span>
        <strong style={{ fontWeight: "bolder" }}>{data?.maxmemb} </strong>
        <strong style={{ marginLeft: 6 }}>(직접 {data?.invitememb})</strong>

        {(data?.state === 1 || data?.state === 4) && (
          <MemberBadge>
            {data?.members === data?.maxmemb ? "FULL" : "모집중"}
          </MemberBadge>
        )}
      </>,
      <>
        <LineBtn
          btnText="설정"
          btnColor="white"
          disabled={!auth?.partyInfo}
          btnClickEvent={() => {
            return setRecruitmentSetModal(true);
          }}
          style={{ marginLeft: "auto" }}
        />
      </>,
      {
        /* </Flex>, */
      },
    ],
    [
      <SecretTime isSecret={data?.isSecret}>
        {data?.isSecret
          ? `${dayjs(data?.isSecret)?.format("YYYY.MM.DD HH:mm")} 까지`
          : "OFF"}
      </SecretTime>,
      <>
        <LineBtn
          btnText={data?.isSecret ? "설정" : "설정"}
          btnColor="white"
          disabled={
            data?.state === 0 ||
            data?.state === 2 ||
            data?.state === 3 ||
            !auth?.partyInfo
          }
          btnClickEvent={() => {
            return setSecretSetModal(true);
          }}
        />
      </>,
    ],
    data?.parentPid
      ? [
          <>
            <strong style={{ fontWeight: "bolder" }}>{data?.parentPid}</strong>
            <span style={{ marginLeft: 6 }}>
              {getSubsNameBySubsId3(data?.parentServsubsid ?? 0)}
            </span>
          </>,
          <ArrowBtn
            className="material-icons-outlined"
            onClick={() => navigate(`/party/info/${data?.parentPid}`)}
          >
            chevron_right
          </ArrowBtn>,
        ]
      : null,
    data?.childPid
      ? [
          <>
            <strong style={{ fontWeight: "bolder" }}>{data?.childPid}</strong>
            <span style={{ marginLeft: 6 }}>
              {getSubsNameBySubsId3(data?.childServsubsid ?? 0)}
            </span>
          </>,
          <ArrowBtn
            className="material-icons-outlined"
            onClick={() => navigate(`/party/info/${data?.childPid}`)}
          >
            chevron_right
          </ArrowBtn>,
        ]
      : null,
  ];

  return (
    <LineBox boxHeight="100%">
      <>
        <TitleWithLine title="기본 정보" />

        <Blank blankHeight={24} />

        <VerticalTable
          tableHeaderData={defaultInfoHeader}
          tableFlexBodyData={status === 200 ? defaultInfoBody : [""]}
          tableMinWidth={360}
        />

        {/* 파티 종료일 변경 모달 */}
        {endDateSetModal && (
          <EndDateSetModal
            cancelEvent={() => setEndDateSetModal(false)}
            partyId={data?.partyid!}
            enddate={data?.enddate ?? ""}
            updateEvent={() =>
              fetchData({
                method: "get",
                url: `party/${data?.partyid}`,
              })
            }
          />
        )}

        {/* 모집인원 설정 모달 */}
        {recruitmentSetModal && (
          <RecruitmentSetModal
            cancelEvent={() => setRecruitmentSetModal(false)}
            partyId={data?.partyid!}
            subsId={data?.servsubsid ?? 0}
            maxmemb={Number(data?.maxmemb) || 0}
            members={Number(data?.members) || 0}
            invitememb={Number(data?.invitememb) || 0}
            updateEvent={() =>
              fetchData({
                method: "get",
                url: `party/${data?.partyid}`,
              })
            }
          />
        )}

        {/* 시크릿 모드 설정 모달 */}
        {secretSetModal && (
          <SecretModeSetModal
            cancelEvent={() => setSecretSetModal(false)}
            secretOffEvent={() => {
              setSecretOffAlertModal(true);
              setSecretModeOffBtnClick(false);
              setSecretSetModal(false);
            }}
            isSecret={data?.isSecret ?? ""}
            partyId={data?.partyid!}
            updateEvent={() =>
              fetchData({
                method: "get",
                url: `party/${data?.partyid}`,
              })
            }
          />
        )}

        {/* 시크릿 모드 해제 모달 */}
        {secretOffAlertModal && (
          <AlertModal
            title={`시크릿 모드를 해제하시겠습니까?`}
            cancelEvent={() => setSecretOffAlertModal(false)}
            confirmText="해제"
            confirmEvent={() => {
              console.log("298329829382932893829328", secretModeOffBtnClick);

              setSecretModeOffBtnClick(true);
            }}
            btnColor="mint"
          />
        )}
      </>
    </LineBox>
  );
}

const ArrowBtn = styled.span`
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.buttonColor.lineHover};
`;

const MemberBadge = styled.label`
  margin-left: 8px;
  padding: 4px 6px;
  border-radius: 3px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
  text-align: center;
  color: ${({ theme }) => theme.color.gray400};
`;

const SecretTime = styled.span<SSecretTime>`
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  text-align: left;
  color: ${({ theme, isSecret }) =>
    isSecret ? theme.buttonColor.blueNormal : theme.color.gray400};
`;

const PartyDateContainer = styled.div<SPartyDateContainer>`
  display: flex;
  flex-direction: ${({ hasExitDate }) => (hasExitDate ? "column" : "row")};
`;

const Date = styled.span`
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  text-align: left;
  color: ${({ theme }) => theme.color.textColor};
`;

const ExitDate = styled(Date)`
  text-decoration: line-through;
  margin-right: 4px;
`;
